export class Api {
    constructor() {
        this.homePopupShow = false;
        this.scrollPositionMosaic = 0;
        this.scrollPositionHome = 0;
        this.uri = "";
        this.operation_code = "";
        this.shop_id = "";
        this.operations = {};
        this.mosaics = {};
        this.categories = {};
        this.subCategories = {};
        this.brands = {};
        this.products = {};
        this.other_books = {};
        this.pages = {};
        this.all_pages = {};
        this.all_products = {};
        this.scrollPositionMosaic = 0;
        this.scrollPositionHome = 0;
    }
    setLocation(location) {
        this.location = location;
    }
    setUri(uri) {
        this.uri = uri;
    }
    setUploadUri(upload_uri) {
        this.upload_uri = upload_uri;
    }
    setOperationCode(operation_code) {
        this.operation_code = operation_code;
    }
    setShopId(shop_id) {
        this.shop_id = shop_id;
    }
    isPopupHomeShow() {
        return this.homePopupShow;
    }
    popupHomeShow() {
        this.homePopupShow = true;
    }
    getBaseUrl() {
        return this.uri + "/" + this.operation_code + "/" + this.shop_id;
    }
    getOperationCode() {
        return this.operation_code;
    }
    getShopId() {
        return this.shop_id;
    }
    sendContentSquareEvent(event = null) {
        let activeOperations = [
            "22G303G",
            "22G096G",
            "22G106G",
            "22G022G",
            "22G023G",
            "22G107G",
            "22G205G",
            "22G092G",
            "22G304G",
            "22G305G",
            "22G306G",
            "22G003G"
        ];
        if (activeOperations.indexOf(this.getOperationCode()) !== -1 && window.location.host.indexOf("-webview") === -1) {
            window._uxa = window._uxa || [];
            try {
                if (event !== null) {
                    window._uxa.push(['setCustomVariable', 1, event.name, event.value, 3]);
                }
            }
            catch (e) { }
            let path = this.location.pathname; //+ this.location.search;
            if (typeof CS_CONF === 'undefined') {
                window._uxa.push(['setPath', path]);
                var mt = document.createElement('script');
                mt.type = 'text/javascript';
                mt.async = true;
                mt.src = '//t.contentsquare.net/uxa/39b8d189f1371.js';
                document.getElementsByTagName('head')[0].appendChild(mt);
            }
            else {
                if (event && event.name === "ProspectusAddToMemo") {
                    path += event.urlSuffixe;
                }
                window._uxa.push(['trackPageview', path]);
            }
        }
    }
    async getOperation() {
        if (!this.operations[this.shop_id]) {
            this.operations[this.shop_id] = {};
        }
        let operations = this.operations[this.shop_id];
        if (operations[this.operation_code]) {
            return Promise.resolve(operations[this.operation_code]);
        }
        else {
            let res = await this.get(this.getBaseUrl());
            operations[this.operation_code] = res;
            return Promise.resolve(res);
        }
    }
    /***
     * Get op with code operation
     */
    async getOperationByCode() {
        if (!this.operations[this.shop_id]) {
            this.operations[this.shop_id] = {};
        }
        let operations = this.operations[this.shop_id];
        if (operations[this.operation_code]) {
            return Promise.resolve(operations[this.operation_code]);
        }
        else {
            let res = await this.get(this.uri + "/operations/" + this.operation_code);
            operations[this.operation_code] = res;
            return Promise.resolve(res);
        }
    }
    async getMosaic() {
        if (!this.mosaics[this.operation_code]) {
            this.mosaics[this.operation_code] = {};
        }
        if (this.mosaics[this.operation_code][this.shop_id]) {
            return Promise.resolve(this.mosaics[this.operation_code][this.shop_id]);
        }
        else {
            let res = await this.get(this.getBaseUrl() + '/mosaic');
            this.mosaics[this.operation_code][this.shop_id] = res;
            return Promise.resolve(res);
        }
    }
    async getCategories() {
        let operation = await this.getOperation();
        if (!operation.documentUid && this.shop_id === "0000") {
            let res = await this.get(`${this.uri}/${operation.code}/${this.shop_id}/categories`);
            return Promise.resolve(res);
        }
        else if (!this.categories[operation.documentUid]) {
            let res = await this.get(this.uri + '/documents/' + operation.documentUid + '/categories');
            this.categories[operation.documentUid] = res;
        }
        return Promise.resolve(this.categories[operation.documentUid]);
    }
    async getSubCategories(id) {
        let operation = await this.getOperation();
        if (!operation.documentUid && this.shop_id === "0000") {
            let res = await this.get(`${this.uri}/${operation.code}/${this.shop_id}/categories/${id}`);
            return Promise.resolve(res);
        }
        else {
            if (!this.subCategories[operation.documentUid]) {
                this.subCategories[operation.documentUid] = {};
            }
            if (!this.subCategories[operation.documentUid][id]) {
                let res = await this.get(this.uri + '/documents/' + operation.documentUid + '/categories');
                this.subCategories[operation.documentUid][id] = res;
            }
        }
        return Promise.resolve(this.subCategories[operation.documentUid][id]);
    }
    async getBrands() {
        if (!this.brands[this.operation_code]) {
            this.brands[this.operation_code] = {};
        }
        if (this.brands[this.operation_code][this.shop_id]) {
            return Promise.resolve(this.brands[this.operation_code][this.shop_id]);
        }
        else {
            let res = await this.get(this.getBaseUrl() + '/brands');
            this.brands[this.operation_code][this.shop_id] = res;
            return Promise.resolve(res);
        }
    }
    /**
     * Get op brands
     * @returns list of brands
     */
    async getBrandsByOperation() {
        let op = await this.getOperationByCode();
        if (!op)
            return [];
        if (!this.brands[this.operation_code]) {
            this.brands[this.operation_code] = {};
        }
        if (this.brands[this.operation_code][this.shop_id]) {
            return Promise.resolve(this.brands[this.operation_code][this.shop_id]);
        }
        else {
            let res = await this.get(this.uri + "/operations/" + op.uid + '/brands');
            this.brands[this.operation_code][this.shop_id] = res;
            return Promise.resolve(res);
        }
    }
    async getProducts(fo) {
        let temp_products = [];
        let operation = await this.getOperation();
        if (!operation.documentUid && this.shop_id === "0000") {
            let res = await this.get(`${this.uri}/${operation.code}/${this.shop_id}/products`);
            return Promise.resolve(this.filterProduct(res, fo));
        }
        else {
            if (this.all_products[operation.documentUid]) {
                temp_products = this.all_products[operation.documentUid];
            }
            else {
                let res = await this.get(this.uri + '/documents/' + operation.documentUid + '/products');
                this.all_products[operation.documentUid] = res;
                temp_products = res;
            }
        }
        return Promise.resolve(this.filterProduct(temp_products, fo));
    }
    async getProductsByOperation(fo) {
        let temp_products = [];
        if (this.all_products[this.operation_code]) {
            temp_products = this.all_products[this.operation_code];
        }
        else {
            let res = await this.get(this.uri + '/operations/' + this.operation_code + '/products');
            this.all_products[this.operation_code] = res;
            temp_products = res;
        }
        return Promise.resolve(this.filterProduct(temp_products, fo));
    }
    async getProductByCampaign(campaign_uid, fo) {
        let temp_products = [];
        // if (this.all_products[campaign_uid]) {
        //     temp_products = this.all_products[campaign_uid];
        // } else {
        let res = await this.get(this.uri + '/operation/' + campaign_uid + '/products');
        this.all_products[campaign_uid] = res;
        temp_products = res;
        // }
        return Promise.resolve(this.filterProduct(temp_products, fo));
    }
    async getProductByDocument(document_uid, fo) {
        let temp_products = [];
        // if (this.all_products[document_uid]) {
        //     temp_products = this.all_products[document_uid];
        // } else {
        let res = await this.get(this.uri + '/documents/' + document_uid + '/products');
        this.all_products[document_uid] = res;
        temp_products = res;
        // }
        return Promise.resolve(this.filterProduct(temp_products, fo));
    }
    filterProduct(products, fo) {
        if (fo && fo.length > 0) {
            let products_filtered = [];
            for (let j = 0; j < fo.length; j++) {
                const filter = fo[j];
                const keys = Object.keys(filter);
                for (let ik = 0; ik < keys.length; ik++) {
                    const key = keys[ik];
                    filter[key].values = filter[key].values.map(element => {
                        return element.toLowerCase();
                    });
                    for (let i = 0; i < products.length; i++) {
                        const p = products[i];
                        p[key] = typeof p[key] === 'string' ? p[key].toLowerCase() : p[key];
                        if (Array.isArray(p[key])) {
                            for (let k = 0; k < p[key].length; k++) {
                                const element = p[key][k];
                                if (filter[key].matchLevel === "exactly" && filter[key].values.indexOf(element) !== -1) {
                                    if (products_filtered.findIndex(e => e.uid === p.uid) === -1) {
                                        products_filtered.push(p);
                                    }
                                    break;
                                }
                            }
                        }
                        else {
                            if (filter[key].matchLevel === "exactly" && filter[key].values.indexOf(p[key]) !== -1) {
                                if (products_filtered.findIndex(e => e.uid === p.uid) === -1) {
                                    products_filtered.push(p);
                                }
                            }
                            else if (filter[key].matchLevel === "partially") {
                                for (let l = 0; l < filter[key].values.length; l++) {
                                    const value = filter[key].values[l].toLowerCase();
                                    const valueSort = this.makeSortString(value);
                                    const pSort = this.makeSortString(p[key].toLowerCase());
                                    if (pSort.indexOf(valueSort) !== -1) {
                                        if (products_filtered.findIndex(e => e.uid === p.uid) === -1) {
                                            products_filtered.push(p);
                                        }
                                        break;
                                    }
                                }
                            }
                        }
                    }
                }
            }
            return products_filtered;
        }
        else {
            return products;
        }
    }
    async getCategoriesByCampaign() {
        let res = await this.get(this.uri + '/' + this.operation_code + '/' + this.shop_id + "/categories");
        return Promise.resolve(res);
    }
    async getCategoriesByDocument(document_uid) {
        let res = await this.get(this.uri + '/documents/' + document_uid + '/categories');
        return Promise.resolve(res);
    }
    async getProduct(productId) {
        if (!this.products[this.operation_code]) {
            this.products[this.operation_code] = {};
        }
        if (!this.products[this.operation_code][this.shop_id]) {
            this.products[this.operation_code][this.shop_id] = {};
        }
        let products = this.products[this.operation_code][this.shop_id];
        if (products[productId]) {
            return Promise.resolve(products[productId]);
        }
        else {
            let res = await this.getDirect('/products/' + productId);
            products[productId] = res;
            return Promise.resolve(res);
        }
    }
    getProductImageSrc(productId, size, fileName) {
        return this.getBaseUrl() + '/products/' + productId + "/img/" + size + "/" + fileName;
    }
    async getOtherBooks() {
        if (!this.other_books[this.operation_code]) {
            this.other_books[this.operation_code] = {};
        }
        if (this.other_books[this.operation_code][this.shop_id]) {
            return Promise.resolve(this.other_books[this.operation_code][this.shop_id]);
        }
        else {
            let res = await this.get(this.getBaseUrl() + '/other_catalogs');
            this.other_books[this.operation_code][this.shop_id] = res;
            return Promise.resolve(res);
        }
    }
    async getPages() {
        let operation = await this.getOperation();
        if (this.all_pages[operation.documentUid]) {
            return Promise.resolve(this.all_pages[operation.documentUid]);
        }
        else {
            let res = await this.get(this.uri + '/documents/' + operation.documentUid + '/pages');
            this.all_pages[operation.documentUid] = res;
            return Promise.resolve(res);
        }
    }
    async getPageByUid(uid) {
        var _a;
        let operation = await this.getOperation();
        if (!this.pages[operation.documentUid]) {
            await this.getPages();
        }
        let page = (_a = this.all_pages[operation.documentUid]) === null || _a === void 0 ? void 0 : _a.filter(p => { return p.uid === uid; })[0];
        return Promise.resolve(page);
    }
    /**
     * get route {url}/{operation_code}/{shop_id}/{path}
     * @param path
     */
    async get(path) {
        return this.request('GET', path, null, null);
    }
    /**
     * getDirect route {url}/{path}
     * @param path
     */
    async getDirect(path) {
        return this.requestDirect('GET', path, null, null);
    }
    async getProductListPdf(products) {
        let body = { products: products };
        return this.post(this.uri + '/pdf/products', body);
    }
    async getCartShoppingListPdf(shoppingList) {
        let body = { shoppingList };
        return this.post(`${this.uri}/${this.getOperationCode()}/${this.getShopId()}/cart/shoppingList/pdf`, body);
    }
    async postCartShoppingList(cart, exp, rec, msg) {
        let body = { shoppingListShare: { cart, exp, rec, msg } };
        return this.post(`${this.uri}/${this.getOperationCode()}/${this.getShopId()}/cart/shoppingList/share`, body);
    }
    async postCartClickCollect(cart) {
        let body = { clickCollect: { cart } };
        return this.post('/cart/clickCollect/send', body);
    }
    async postExcelImport(documentUid, file, token) {
        let data = new FormData();
        data.append('file', file);
        return this.postFile(this.upload_uri + "/documents/" + documentUid + "/import/excel", token, data);
    }
    async postPdfImport(documentUid, file, token) {
        let data = new FormData();
        data.append('file', file);
        return this.postFile(this.upload_uri + "/documents/" + documentUid + "/import/pdf", token, data);
    }
    async postPdfToDatafile(file) {
        let data = new FormData();
        data.append('file', file);
        return this.postFile(this.upload_uri + "/pdf/import", null, data);
    }
    async postOrderImport(campaignUid, mFileContentStr, token) {
        let data = new FormData();
        data.append('mFileStr', mFileContentStr);
        return this.postFile(this.upload_uri + "/operations/" + campaignUid + "/import/orders", token, data);
    }
    async addOrderOnDocument(documentUid, shopCode, token) {
        let headers = new Headers();
        headers.append('Authorization', 'Bearer ' + token);
        return this.request('POST', `${this.uri}/add/order/${documentUid}/${shopCode}`, null, headers);
    }
    // async postMosaic(mosaic: Mosaic): Promise<any> {
    //     let body = {'mosaic': mosaic};
    //     return this.post('/mosaic', body);
    // }
    async post(path, body = null) {
        return this.request('POST', path, body, null);
    }
    async postFile(path, token, body = null) {
        let headers = new Headers();
        headers.append('Authorization', 'Bearer ' + token);
        const response = await fetch(path, { method: 'POST', body, headers });
        let res;
        let contentType = response.headers.get('content-type');
        if (contentType === "application/json") {
            res = await response.json();
        }
        else {
            res = await response;
        }
        if (!response.ok) {
            console.log(res);
            return Promise.reject(new Error(res));
        }
        else {
            return res;
        }
    }
    async deleteCampaign(operationCode, token) {
        return this.delete(`${this.uri}/operations/${operationCode}`, token);
    }
    async deleteDocument(documentUid, token) {
        return this.delete(`${this.uri}/documents/${documentUid}/delete`, token);
    }
    async delete(path, token, body = null) {
        let headers = new Headers();
        headers.append('Authorization', 'Bearer ' + token);
        return this.request('DELETE', path, body, headers);
    }
    /**
     * request route {url}/{operation_code}/{shop_id}/{path}
     * @param method
     * @param path
     * @param body
     * @param headers
     */
    async request(method, path, body, headers) {
        if (!headers) {
            headers = new Headers();
        }
        headers.append('Accept-Encoding', 'zlib');
        const response = await fetch(path, this.params(method, body, headers));
        let json;
        let contentType = response.headers.get('content-type');
        if (contentType === "application/pdf") {
            json = await response.blob();
        }
        else {
            json = await response.json();
        }
        if (!response.ok) {
            return Promise.reject(new Error(json.error.message));
        }
        else {
            return json;
        }
    }
    /**
     * requestDirect route {url}/{path}
     * @param method
     * @param path
     * @param body
     * @param headers
     */
    async requestDirect(method, path, body, headers) {
        headers = new Headers();
        headers.append('Accept-Encoding', 'zlib');
        const response = await fetch(this.uri + path, this.params(method, body, headers));
        let json;
        let contentType = response.headers.get('content-type');
        if (contentType === "application/pdf") {
            json = await response.blob();
        }
        else {
            json = await response.json();
        }
        if (!response.ok) {
            return Promise.reject(new Error(json.error.message));
        }
        else {
            return json;
        }
    }
    params(method, body, headers) {
        if (!headers) {
            headers = new Headers();
        }
        let params = {
            method: method,
            mode: 'cors',
            headers: headers,
            body: null,
        };
        if (body && Object.keys(body).length !== 0 && body.constructor === Object) {
            params.headers.append('Content-Type', 'application/x-www-form-urlencoded;charset=UTF-8');
            params.headers.append('Access-Control-Allow-Origin', '*');
            let formBody = new URLSearchParams();
            let attrName = Object.getOwnPropertyNames(body)[0];
            formBody.set(attrName, JSON.stringify(body[attrName]));
            params.body = formBody;
        }
        return params;
    }
    makeSortString(s) {
        const translate = {
            "ä": "a", "ö": "o", "ü": "u",
            "Ä": "A", "Ö": "O", "Ü": "U",
            "é": "e", "è": "e", "È": "E",
            "É": "E", "â": "a", "Â": "A",
            "û": "u", "Û": "U", "ù": "u",
            "Ù": "U"
        };
        const translate_re = /[öäüÖÄÜéèÈÉâÂûÛùÙ]/g;
        return (s.replace(translate_re, function (match) {
            return translate[match];
        }));
    }
}
